module.exports = __webpack_public_path__ + "static/media/4-2.d9fcc251.png";